<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <span class="cursor-pointer flex items-center i18n-locale">
      <img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
      <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>
    </span>
    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item @click="updateLocale('en')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;English</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('fr')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/fr.png" alt="fr" /> &nbsp;Française</vs-dropdown-item><!-- French -->
      <vs-dropdown-item @click="updateLocale('de')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/de.png" alt="de" /> &nbsp;Deutsche</vs-dropdown-item><!-- German -->
      <vs-dropdown-item @click="updateLocale('pt')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/pt.png" alt="pt" /> &nbsp;Português</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('es')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/es.png" alt="es" /> &nbsp;Española</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('nl')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/nl.png" alt="nl" /> &nbsp;Nederlands</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('it')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/it.png" alt="it" /> &nbsp;Italiana</vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  computed: {
    i18n_locale_img () {
      return require(`@/assets/images/flags/${this.$i18n.locale}.png`)
    },
    getCurrentLocaleData () {
      const locale = this.$i18n.locale
      if (locale === 'en')      return { flag: 'us', lang: 'English'    }
      else if (locale === 'pt') return { flag: 'br', lang: 'Português' }
      else if (locale === 'fr') return { flag: 'fr', lang: 'Française'     }
      else if (locale === 'de') return { flag: 'de', lang: 'Deutsche'     }
      
      else if (locale === 'es') return { flag: 'es', lang: 'Española' }
      else if (locale === 'nl') return { flag: 'nl', lang: 'Nederlands'     }
      else if (locale === 'it') return { flag: 'it', lang: 'Italiana'     }
    }
  },
  methods: {
    updateLocale (locale) {
      this.$i18n.locale = locale
      localStorage.setItem('locale', locale);
    }
  }
}
</script>
